var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.362 16.7721C16.1441 13.2837 13.3358 10.842 10.066 10.842C6.79886 10.842 3.99246 13.2798 2.77292 16.7636",
    stroke: "#233544",
    strokeWidth: 1.64,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91234 10.0001C12.0052 10.0001 13.7018 8.30349 13.7018 6.21062C13.7018 4.11775 12.0052 2.42114 9.91234 2.42114C7.81947 2.42114 6.12286 4.11775 6.12286 6.21062C6.12286 8.30349 7.81947 10.0001 9.91234 10.0001Z",
    stroke: "#233544",
    strokeWidth: 1.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.f72010622a29d546cc9240dda827ba0a.svg";
export { ForwardRef as ReactComponent };